import React from 'react';
import { Image } from '../../ui/Image';

interface PleriLogoProps {
  size?: number;
  className?: string;
  smallImage?: boolean;
}

export const PleriLogo: React.FC<PleriLogoProps> = ({
  size = 24,
  className = '',
  smallImage = true,
}) => {
  return (
    <Image
      width={size}
      type="plerionLogo"
      height={size}
      name={smallImage ? 'pleri-512' : 'pleri-512'}
      className={`${className || 'rounded-md'}`}
    />
  );
};
